export const WordCompletionStatus = {
  UPCOMING: "upcoming",
  CURRENT: "current",
  CORRECT: "correct",
  INCORRECT: "incorrect",
};

export type WordCompletionStatusType =
  | typeof WordCompletionStatus.UPCOMING
  | typeof WordCompletionStatus.CURRENT
  | typeof WordCompletionStatus.CORRECT
  | typeof WordCompletionStatus.INCORRECT;

export interface SpellingBeeState {
  isOnIntro: boolean;
  completedWordIndex: number;
  completedWordStatuses: Array<WordCompletionStatusType>;
}

export const INITIAL_STATE: SpellingBeeState = {
  isOnIntro: true,
  completedWordIndex: 0,
  completedWordStatuses: [],
};

export const SpellingBeeAction = {
  INTRO_CLOSED: "INTRO_CLOSED",
  ANSWERED_CORRECTLY: "ANSWERED_CORRECTLY",
  ANSWERED_INCORRECTLY: "ANSWERED_INCORRECTLY",
  ROUND_COMPLETED: "ROUND_COMPLETED",
} as const;

export type SpellingBeeAction =
  | { type: typeof SpellingBeeAction.INTRO_CLOSED }
  | { type: typeof SpellingBeeAction.ANSWERED_CORRECTLY }
  | { type: typeof SpellingBeeAction.ANSWERED_INCORRECTLY }
  | { type: typeof SpellingBeeAction.ROUND_COMPLETED };

export function spellingBeeReducer(
  state: SpellingBeeState,
  action: SpellingBeeAction,
) {
  switch (action.type) {
    case SpellingBeeAction.INTRO_CLOSED:
      return {
        ...state,
        isOnIntro: false,
      };
    case SpellingBeeAction.ANSWERED_CORRECTLY:
      return {
        ...state,
        completedWordIndex: state.completedWordIndex + 1,
        completedWordStatuses: [
          ...state.completedWordStatuses,
          WordCompletionStatus.CORRECT,
        ],
      };
    case SpellingBeeAction.ANSWERED_INCORRECTLY:
      return {
        ...state,
        completedWordIndex: state.completedWordIndex + 1,
        completedWordStatuses: [
          ...state.completedWordStatuses,
          WordCompletionStatus.INCORRECT,
        ],
      };
    case SpellingBeeAction.ROUND_COMPLETED:
      return INITIAL_STATE;
    default:
      return state;
  }
}
